import { render, staticRenderFns } from "./bathingatHome.vue?vue&type=template&id=fb19628e&scoped=true&"
import script from "./bathingatHome.vue?vue&type=script&lang=js&"
export * from "./bathingatHome.vue?vue&type=script&lang=js&"
import style0 from "./bathingatHome.vue?vue&type=style&index=0&id=fb19628e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb19628e",
  null
  
)

export default component.exports